module.exports = __webpack_public_path__ + "img/odt (2).16fd20b5.svg";